export default (request) => ({
  getHouseFundDetails: (houseFundId, options = {}) => request({
    method: 'get',
    url: `/portfolios/housefunds/${houseFundId}`,
    ...options,
  }),
});
